module.exports = __webpack_public_path__ + "static/attention-training-b79783093bab86073d6f885a31bec34f.jpg";